export default "__VITE_ASSET__1WWWn553__"